module.exports = __webpack_public_path__ + "static/media/view2.c637aaf5.jpg";